import { createAction } from 'redux-actions';

export const createTransactionTaskAction = createAction('CREATE_TRANSACTION_TASK');
export const createTaskCategoryAction = createAction('CREATE_TASK_CATEGORY');
